<template>
  <TabLayout class="marketing" :tabs="tabs">
    <template v-slot:title>
      <h1 class="mb-0">{{ $t('Temporary Items') }}</h1>
    </template>
    <template v-slot:buttons>
      <add-new-button v-permission="'change_temporaryinventoryitem'" class="btn btn-primary" @click="onAddClick()">
        <font-awesome-icon icon="plus-circle" class="icon"/>
        {{ $t('New Temporary Item') }}
      </add-new-button>
    </template>
  </TabLayout>
</template>

<script>
  import TabLayout from "@/core/components/layout/DefaultLayout/TabLayout";
  import i18n from "@/shared/i18n";
  import _ from "lodash";
  import {SOURCE_TEMPORARY_ITEMS_TABLE} from "@/modules/constants";
  import {createNamespacedHelpers} from "vuex";
  import AddNewButton from "@/core/components/common/AddNewButton";

  const {mapActions} = createNamespacedHelpers('temporaryItems');
  //const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "TemporaryItems",
    components: {AddNewButton, TabLayout},
    data() {
      return {
        tabs: [
          {title: i18n.t('Active'), icon: 'list', to: {name: 'temporary.active'}},
          {title: i18n.t('Archived'), icon: 'list', to: {name: 'temporary.archived'}},
        ],
      }
    },
    methods: {
      ...mapActions([
        'showModal'
      ]),
      async onAddClick(item) {
        this.showModal({
          object: _.cloneDeep(item),
          source: SOURCE_TEMPORARY_ITEMS_TABLE
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>
